<div mat-dialog-content class="form-container">
  <form [formGroup]="datosUser">
    <h1>Alta Usuario</h1>
    <p>Al dar de alta a un usuario se enviará un email con los datos de autenticación</p>
    <div>
      <h2>Identificación de Usuario</h2>
      <mat-form-field appearance="outline">
        <mat-label>Nombre</mat-label>
        <input
          matInput
          placeholder="Nombre"
          formControlName="name"
          required
        />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Apellido</mat-label>
        <input matInput placeholder="Apellido" formControlName="surname" required />
      </mat-form-field>
    </div>
    <div>
      <mat-form-field appearance="outline">
        <mat-label>Mail</mat-label>
        <input matInput placeholder="Mail" formControlName="email" required />
      </mat-form-field>
      
    </div>

      <h2>Tipo de Usuario</h2>
      <div class="displayFlexJustifyAlign">
        <div class="radioButton displayFlexJustify">
          <div class="displayFlexJustifyAlign radio__users">
            <input type="radio" id="inproeco" name="radiobutton" (click)="onCheckedInproeco($event)"/>
            <label for="cliente">Inproeco</label>
          </div>
          <div class="displayFlexJustifyAlign radio__users">
            <input type="radio" id="cliente" name="radiobutton" (click)="onCheckedCliente($event)"/>
            <label for="cliente">Cliente</label>
          </div>
          <div class="displayFlexJustifyAlign radio__users">
            <input type="radio" id="contratista" name="radiobutton" (click)="onCheckedContratista($event)"/>
            <label for="contratista">Contratista</label>
          </div>
        </div>
      </div>
    

    <div *ngIf="isCliente">
      <div>
        <mat-form-field appearance="outline" class="dropdown">
          <mat-select placeholder="Cliente" class="selector__motivo" formControlName="cliente" (selectionChange)="onChangeCliente()">
            <div *ngFor="let cliente of clientes">
              <mat-option value="{{ cliente.id }}" >
                {{ cliente.nombreComercial }}
              </mat-option>
            </div>
          </mat-select>
        </mat-form-field>
      </div>

      <mat-form-field appearance="outline" class="dropdown">
        <mat-select placeholder="Zona" class="selector__motivo" formControlName="zonas" multiple>
          <div *ngFor="let zona of zonas">
            <mat-option value="{{ zona.id }}">
              {{ zona.nombre }}
            </mat-option>
          </div>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="dropdown">
        <mat-select placeholder="Grupo" class="selector__motivo" formControlName="grupos" multiple>
          <div *ngFor="let grupo of grupos">
            <mat-option value="{{ grupo.id }}">
              {{ grupo.nombre }}
            </mat-option>
          </div>
        </mat-select>
      </mat-form-field>
    </div>

    <div *ngIf="isContratista">
      <mat-form-field appearance="outline" class="dropdown">
        <mat-select placeholder="Contratista" class="selector__motivo" formControlName="contratista">
          <div *ngFor="let contratista of contratistas">
            <mat-option value="{{contratista.id}}" >
              {{ contratista.nombreComercial }}
            </mat-option>
          </div>
        </mat-select>
      </mat-form-field>
    </div>

 
      <h2>Permisos</h2>
      <div class="displayFlexJustifyAlign">
        <div class="radioButton displayFlexJustify">
          <div class="displayFlexJustifyAlign radio__users">
            <input type="radio" name="radiobuttonrole" id="role" formControlName="rol" (click)="onCheckedAdmin($event)"/>
            <label for="cliente">Edición y consulta</label>
          </div>
          <div class="displayFlexJustifyAlign radio__users">
            <input type="radio" name="radiobuttonrole" id="role" formControlName="rol" (click)="onCheckedUser($event)"/>
            <label for="contratista">Consulta</label>
          </div>
        </div>
      </div>
    

    <div>
      <button style="margin-top: 2rem;"
        type="submit"
        (click)="saveUser()"
        [mat-dialog-close]
        [disabled]="datosUser.invalid"
      >
        Hecho
      </button>
    </div>
  </form>
</div>
